import React from 'react';
import './index.css';

// Shows a technology's logo image, or its icon on an accent gradient.
const TechLogo = ({ tech, size = 48 }) => {
  const Icon = tech.icon;
  return (
    <span
      className={`tech-logo ${Icon ? 'tech-logo-icon' : ''}`}
      style={{
        width: size,
        height: size,
        // Percentage padding would resolve against the parent's width, so size it from the logo
        padding: Icon ? 0 : Math.round(size * 0.18),
        '--accent-1': tech.accent[0],
        '--accent-2': tech.accent[1]
      }}
    >
      {Icon ? <Icon sx={{ fontSize: size * 0.55 }} /> : <img src={tech.logo} alt="" loading="lazy" />}
    </span>
  );
};

export default TechLogo;
